import * as React from "react";
import { formatDistance } from "date-fns";
import { Fragment } from "core/models/Fragment";
import { Tooltip, FlagBar } from "ui/components";
import formatByteCount from "utils/formatByteCount";
import formatDuration from "utils/formatDuration";
import styles from "./FragmentPreview.module.scss";

interface Props {
    fragment: Fragment;
}

const FragmentPreview: React.FC<Props> = ({ fragment }) => (
    <div className={styles.container}>
        <div
            className={styles.thumbnail}
            style={{
                backgroundImage: `url(${fragment.getThumbnailURL()})`,
            }}
        >
            <div className={styles.thumbnail__duration}>
                {formatDuration(
                    fragment.variants[0].mediaFileProperties.mediaProperties
                        .duration || 0,
                )}
            </div>
        </div>
        <div className={styles.details}>
            <span className={styles.item__file__size}>
                <Tooltip text="Size">
                    {formatByteCount(
                        fragment.variants[0].mediaFileProperties.mediaProperties
                            .size,
                    )}
                </Tooltip>
            </span>
            <FlagBar fragment={fragment} />
            <div className={styles.details__title}>{fragment.title}</div>
            <div className={styles.details__author}>
                <span className={styles.details__authorname}>
                    {fragment.userProperties.username} -{" "}
                </span>
                {`${formatDistance(
                    new Date(),
                    new Date(`${fragment.creationDate}Z`),
                )} ago`}
            </div>
        </div>
    </div>
);

export default FragmentPreview;
